var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-len */
import React from "react";
import id from "@irati/utils/id";
import BaseSvgIcon from "./Base";
var SummaryRecognitions = function (props) {
    var titleId = id("title", props);
    var title = props.title, rest = __rest(props, ["title"]);
    return (React.createElement(BaseSvgIcon, __assign({}, rest, { "aria-labelledby": titleId }),
        React.createElement("path", { d: "m9 5.51481668c.00637615-.0068576.01278295-.01369048.01922032-.02049846 1.25358558-1.32575763 3.29826438-1.32575763 4.55184998 0 1.1854653 1.25371548 1.2362958 3.24293647.1524914 4.55972608l.0058497.0053401-4.7294114 5.0016954-4.5710703-4.8342382c-1.23857293-1.30988067-1.23857293-3.42264273 0-4.73252338 1.25358558-1.32575763 3.2982644-1.32575763 4.55184998 0 .00643737.00680798.01284417.01364086.01922032.02049846z", fill: "#f56a2c", stroke: "#3d3d36", transform: "matrix(-1 0 0 1 18 0)" })));
};
SummaryRecognitions.defaultProps = {
    id: "summary-recognition-icon",
    title: "Recognitions"
};
export default SummaryRecognitions;
